$(document).ready(function() {
  const accordionLinks = $('.js-accordion-trigger');
  accordionLinks.each(function() {
    $(this).on('click', function(event) {
      const windowWidth = $(window).width();
      const content = $(this).next('.js-accordion-content');

      if ($(this).closest('.l-header').length > 0) {
        // .l-header内のjs-accordion-triggerをクリックした場合
        if (windowWidth <= 1279) {
          event.preventDefault();
          $(this).toggleClass('is-accordion-open');
          content.slideToggle(250, 'swing').toggleClass('is-open');
        }
      } else {
        // それ以外のjs-accordion-triggerをクリックした場合
				$(this).toggleClass('is-open');
        content.slideToggle(250, 'swing').toggleClass('is-open');
      }
    });
  });
});

